import type { Components, Theme } from '@mui/material/styles';

const MuiChip: Components<Theme>['MuiChip'] = {
  styleOverrides: {
    /**
     * Корневые стили Chip
     * @param root0 - пропсы
     * @param root0.theme - тема
     */
    root: ({ theme }) => ({
      fontWeight: 500,
      '&.Mui-disabled': {
        color: theme.palette.text.disabled,
        opacity: 1,
        backgroundColor: theme.palette.action.hover
      }
    })
  }
};

export const chip = {
  MuiChip
};
